import React, { useState } from "react"
import Img from "gatsby-image"

const HeartIcon = props => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path d="M12 4.435C10.011-.964 0-.162 0 8.003 0 12.071 3.06 17.484 12 23c8.94-5.516 12-10.929 12-14.997C24-.115 14-.996 12 4.435z" />
    </svg>
  )
}

const CommentIcon = props => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path d="M24 9.874C24 4.42 18.627 0 12 0S0 4.42 0 9.874c0 4.512 3.678 8.317 8.701 9.496L12 24l3.299-4.63C20.322 18.19 24 14.385 24 9.874z" />
    </svg>
  )
}

const InstaImage = ({ node }) => {
  const [isHover, setIsHover] = useState(false)
  if (!node) {
    return null;
  }
  const { comments, likes } = node
  return (
    <a
      href={node.original}
      target="_blank"
      rel="noopener noreferrer"
      className="work-grid-item"
      onMouseOut={() => setIsHover(false)}
      onMouseOver={() => setIsHover(true)}
      style={{ position: "relative" }}
    >
      {node.localFile ? (
        <Img style={{ borderRadius: 'inherit' }} fixed={node.localFile.childImageSharp.fixed} />
      ) : (
        node.id
      )}
      <div
        style={{
          backgroundColor: `rgba(0,0,0,0.4)`,
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: 1,
          borderRadius: 'inherit',
          transition: `opacity ease 0.25s`,
          opacity: isHover ? 1 : 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span style={{ display: 'flex', padding: "0 15px" }}>
          <HeartIcon fill="white" height="16px" />
          {likes ? (
            <span
              style={{
                fontWeight: "lighter",
                color: "white",
                lineHeight: 1,
                fontSize: '16px',
              }}
            >
              {likes}
            </span>
          ) : null}
        </span>
        <span style={{ display: 'flex', padding: "0 15px" }}>
          <CommentIcon fill="white" height="16px" />
          {comments ? (
            <span
              style={{
                fontWeight: "lighter",
                color: "white",
                lineHeight: 1,
                fontSize: '16px',
              }}
            >
              {comments}
            </span>
          ) : null}
        </span>
      </div>
    </a>
  )
}

export default InstaImage
